export default __webpack_public_path__ + "static/media/bounceback.71ec88bc.svg";